import { useCloudflareImage } from '@/hooks/useCloudflareImage';

export const useAuthorProfileImage = ({
  src,
  ...rest
}: Parameters<typeof useCloudflareImage>[0]) => {
  const cloudflareSrc = useCloudflareImage({
    src,
    ...rest,
  });

  if (src !== null && !src.includes('simplywall.st')) {
    return src;
  }

  return cloudflareSrc;
};
